'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _buttonGroup = require('../button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _modal = require('../modal/modal');

var _modal2 = _interopRequireDefault(_modal);

var _emailRegistration = require('./email-registration');

var _emailRegistration2 = _interopRequireDefault(_emailRegistration);

var _emailLogin = require('./email-login');

var _emailLogin2 = _interopRequireDefault(_emailLogin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class emailLoginButton
  * A component for logging a user into the virtual
  * expo using thier email account.
  * @prop {function} onError an error handler for issues
  * arising in the login process.  It should expect an error
  * object as the only parameter.
  */
var emailLoginButtons = function (_Component) {
  _inherits(emailLoginButtons, _Component);

  function emailLoginButtons(props) {
    _classCallCheck(this, emailLoginButtons);

    var _this = _possibleConstructorReturn(this, (emailLoginButtons.__proto__ || Object.getPrototypeOf(emailLoginButtons)).call(this, props));

    _this.state = {
      showRegistation: false,
      showLogin: false
    };
    return _this;
  }
  /** @method render
    * Renders the email login button.
    */


  _createClass(emailLoginButtons, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _buttonGroup2.default,
        null,
        _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return _this2.setState({ showRegistration: true });
            } },
          'New User Registration'
        ),
        _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return _this2.setState({ showLogin: true });
            } },
          'Existing User Login'
        ),
        _react2.default.createElement(
          _modal2.default,
          { show: this.state.showRegistration, onExit: function onExit() {
              _this2.setState({ showRegistration: false });
            } },
          _react2.default.createElement(_emailRegistration2.default, null)
        ),
        _react2.default.createElement(
          _modal2.default,
          { show: this.state.showLogin, onExit: function onExit() {
              _this2.setState({ showLogin: false });
            } },
          _react2.default.createElement(_emailLogin2.default, null)
        )
      );
    }
  }]);

  return emailLoginButtons;
}(_react.Component);

exports.default = emailLoginButtons;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/email/email-login-buttons.js
// module id = 904
// module chunks = 0